module.exports = __webpack_public_path__ + "img/btn-crealo-shadow.ffec7b14.webp";